import React, { useEffect } from 'react';
import styled from 'styled-components';

import { lgRegular, xxlRegular } from '@hud/web-components/theme/typography';
import { themeColor } from '@hud/web-components/theme/colors';

import { StepStyles as Styled } from './SetupSteps.styles';
import useAnalytics from '../../../hooks/useAnalytics';
import { useNavigate } from 'react-router-dom';
import useFirstServiceInfo from '../../../hooks/useFirstServiceInfo';
import { HudIcon } from '@hud/web-components/Icons/HudIcons';

export function SetupCompleteTransition() {
  const analytics = useAnalytics();
  const navigate = useNavigate();

  useEffect(() => {
    analytics.capture('user_redirected_to_webapp_after_metrics');
  }, []);

  const { data: firstServiceInfo } = useFirstServiceInfo();
  const timeFrame = 'hour';

  useEffect(() => {
    const timer = setTimeout(() => {
      if (firstServiceInfo) {
        navigate(
          `/explore/services/${firstServiceInfo.serviceId}?environment=${firstServiceInfo.environmentName}&timeFrame=${timeFrame}`,
        );
      } else {
        navigate('/');
      }
    }, 3000);
    return () => clearTimeout(timer);
  }, [firstServiceInfo]);

  return (
    <StyledContainer>
      <StyledBody>
        <HudIcon icon="other.circledLeanCheck" color="turquoise" size="56px" />

        <Title>You're all set!</Title>
        <Message>
          <p>Hud initialized successfully.</p>
          <p>You can now explore your data.</p>
        </Message>
      </StyledBody>
    </StyledContainer>
  );
}

const StyledContainer = styled(Styled.Container)`
  justify-content: center;
`;

const StyledBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  overflow-y: auto;
  align-items: center;
  text-align: center;
`;

const Title = styled.div`
  ${xxlRegular};
  font-size: 20px;
  color: ${themeColor('textPrimary')};
`;

const Message = styled(Styled.Info)`
  ${lgRegular};
  font-size: 14px;
  color: ${themeColor('textPrimary')};
  line-height: 1.4;
  p {
    margin: 0;
  }
`;
